import { render, staticRenderFns } from "./LiveBanner.vue?vue&type=template&id=314a08a4&"
import script from "./LiveBanner.vue?vue&type=script&lang=js&"
export * from "./LiveBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\larepublica\\LRStatics\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('314a08a4')) {
      api.createRecord('314a08a4', component.options)
    } else {
      api.reload('314a08a4', component.options)
    }
    module.hot.accept("./LiveBanner.vue?vue&type=template&id=314a08a4&", function () {
      api.rerender('314a08a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/lr/js/vue/components/live-banner/LiveBanner.vue"
export default component.exports